import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex p-2",
  style: {
        background: '#F5F7F6',
        color: '#666666'
      }
}
const _hoisted_3 = { class: "ms-4" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex p-2"
}
const _hoisted_5 = { class: "text-blue ms-4 font-bold" }

import { ref, computed } from 'vue'
import { format } from 'date-fns'
import Information from '../../../api/v2/models/information'
import { checkMobile } from '../../utils/utils'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'InformationView',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props

// Reactive Data
const mobile = ref(checkMobile())

// Computed
const dateFormatted = computed(() => format(props.item.createdAt, 'YYYY/MM/DD HH:mm'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.item.readed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            style: _normalizeStyle({
          width: mobile.value ? '100px' : ''
        })
          }, _toDisplayString(dateFormatted.value), 5 /* TEXT, STYLE */),
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.item.title), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            style: _normalizeStyle({
          width: mobile.value ? '100px' : ''
        })
          }, _toDisplayString(dateFormatted.value), 5 /* TEXT, STYLE */),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.title), 1 /* TEXT */)
        ]))
  ]))
}
}

})